import {Select, SelectOptionItem} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import {get} from '@logistics-frontend/utils'
import {useController, useFormContext} from '@yandex-delivery/form'
import React, {useCallback} from 'react'

import {Props} from './DeliveryTimeSelect.types'

export function DeliveryTimeSelect({name, intervals}: Props): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()
  const {field, fieldState} = useController({control, name})

  const changeHandler = useCallback(
    (selected: SelectOptionItem<string> | null) => {
      field.onChange(selected?.value)
    },
    [field],
  )

  return (
    <Select<string>
      error={fieldState.invalid}
      helperText={fieldState.error?.message}
      makeKey={get('value')}
      onBlur={field.onBlur}
      onChange={changeHandler}
      options={intervals}
      placeholder={t('ndd.delivery-policy.input.time.placeholder', 'Выберите интервал')}
      value={field.value}
    />
  )
}
